import { Navigate } from "react-router-dom";
import { clear, useFetchOrderDetailsQuery, useTypedDispatch } from "../store";
import Logo from "../components/common/Logo";
import { FeeTypeText } from "../types";

const PaymentSuccessWrapper = () => {
  const dispatch = useTypedDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const orderIdParam = urlParams.get("orderId");

  if (orderIdParam) {
    dispatch(clear());
    return <PaymentSuccess orderId={orderIdParam} />;
  } else {
    return <Navigate to="/" />;
  }
};

const PaymentSuccess: React.FC<{ orderId: string }> = ({ orderId }) => {
  const { data: order } = useFetchOrderDetailsQuery(orderId);

  if (!order) return <></>;

  const renderedcartItems = order.cart.map((item) => {
    const renderedModifierGroups = item.modifierGroups.map((modG) => {
      const renderedModifierOptions = modG.modifierOptions.map((modO) => {
        return (
          <div
            key={modO.modifierOptionId}
            className="pl-3 flex w-full justify-between"
          >
            <div>
              {modO.title} {`${modO.title}  x${modO.quantity}`}{" "}
            </div>
            <div> {modO.price.text} </div>
          </div>
        );
      });

      return (
        <div
          key={modG.modifierGroupId}
          className="flex flex-col gap-2 ml-3"
        >
          <div className="font-semibold">{modG.title} :</div>
          {renderedModifierOptions}
        </div>
      );
    });

    return (
      <div
        key={item.itemId}
        className="flex flex-col gap-2"
      >
        <div className="flex w-full border-b py-2 text-lg font-bold flex justify-between">
          <div>{`${item.title}  x${item.quantity}`}</div>
          <div> {item.price.baseUnitPrice.text} </div>
        </div>
        {renderedModifierGroups}
      </div>
    );
  });

  const renderedPaymentInfo = (
    <div className="flex flex-col">
      {order.paymentInfo.fees.map((fee, index) => (
        <div
          className="pl-3 flex w-full justify-between"
          key={index}
        >
          <div className="text-lg font-semibold"> {FeeTypeText[fee.type]} </div>
          <div> {fee.value.text} </div>
        </div>
      ))}
      <div className="pl-3 flex w-full justify-between text-xl font-bold">
        <div>Total </div>
        <div> {order.paymentInfo.totalPrice.text} </div>
      </div>
    </div>
  );

  return (
    <div className="w-full flex flex-col bg-secondary min-h-screen items-center justify-center p-4">
      <div className="flex flex-col bg-white p-3 rounded w-5/6 md:w-2/5 items-center gap-2 text-start py-16">
        <Logo />
        <div className="flex flex-col p-3 w-full">
          <div className="text-lg font-semibold">
            {`Commande #${order.displayId}`}
          </div>
          <div className="text-gray-600 border-b pb-4 mb-4">
            {order.createdAt}
          </div>
          <div className="border-b-2 border-primary pb-4 mb-4">
            {renderedcartItems}
          </div>
          {renderedPaymentInfo}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessWrapper;
